<template lang="pug">
  .content
    img(src="@/assets/trophy.png" id="trophy")
    .square {{champion}}
    .score
      table
        tr
          th Position
          th Name
          th Score
        tr(v-for="player, index in players")
          td {{index+1}}.
          td {{player.name}}
          td {{player.score}}

</template>
<script>
import Event from '../event.js';
export default {
  name: 'EndGameComponent',
  props: {
    players: {

    }
  },
  data () {
    return {
      champion: 'Jdcr',
    }
  },
  mounted() {
    Event.$on('champion', (champ) => {
      this.champion = champ.name;
    });
  }
}
</script>
<style lang="scss" scoped>
  .content {
    position: relative;
  }
  #trophy {
    position: absolute;
    height: 425px;
    top: 150px;
    left: 20px;
  }
  .square {
    position: absolute;
    width: 170px;
    height: 40px;
    top: 523px;
    left: 100px;
    background: #DAA732;
    text-align: center;
    font-size: 30px;
  }
  .score {
    position: absolute;
    width: 100px;
    top: 600px;
    left: 20px;
    color: white;
    ul{
      list-style: none;
    }
  }
  table{
    //background: #DAA732;
    border: 1px solid white;
    width: 40vh;
    text-align: left;
    font-size: 20px;
    td{
      width: 33%;
      border-top: 1px solid white;
    }
  }
</style>
